export default {
  NewRoleAdd: 'New Role Add',
  NewRealmAdd: 'New Realm Add ',
  PermissionUpdate: 'Permission Update',
  RealmUpdate: 'Realm Update',
  RoleUpdate: 'Role Update',
  RealmRemoved: 'Realm Removed',
  RoleRemoved: 'Role Removed',
  Realms: 'Realms',
  Agent: 'Agent',
  Permissions: 'Permissions',
  AccessPanel: 'Access Panel',
  ClientType: 'Client Type',
  CreationTime: 'CreationTime',
  CreationTimeMin: 'CreationTime Min',
  CreationTimeMax: 'CreationTime Max',
  Role: 'Role',
  RoleScope: 'Role scope',
  Realm: 'Realm',
  Order: 'Order',
  Slug: 'Slug',
  SerialNumber: 'Serial Number',
  Traversal: 'traversal',
  Version: 'Version',
  VersionTime: 'version Time',
  ProxyIP: 'proxy IP',
  Host: 'Host',
  MainIP: 'Main IP',
  Os: 'Os',
  NodeType: 'Node Type',
  Enable: 'Enable',
  Scope: 'Scope',
  minimum: 'Minimum',
  maximum: 'Maximum',
  limitType: 'Limit type',
  editPermission_: 'Edit permission {title}',
  licenseScope: 'License scope',
  selectAtLeastOnePermissionForThisLicense:
    'Select at least one permission for this license',

  mainIP: 'Main IP',
  proxyIP: 'Proxy IP',
  host: 'Host',
  os: 'Os',
  agent: 'Agent',
  clientType: 'Client type ',
  creationTime: 'Creation type',
  serialNumber: 'Serial number',
  version: 'Version',
  parameter: 'Parameter',
  makeTheDesireFormulaWithTheFollowingWords:
    'Make the desire formula with the following words',
  formulaMaker: 'Formula maker',
  service: 'Service',
  operation: 'Operation',
  type: 'Type',
  pleasePickServiceAndOperation: 'Please pick service ans operation',
  ignoreExpression: 'Ignore conditions',
  userExpression: 'User based conditions',
  generalExpression: 'General user conditions',
  parameters: 'Parameters',
  areYouSureYouWantToDisableThisLimit:
    'Are you sure you want to disable this limit?',
  areYouSureYouWantToRemoveThisLimit:
    'Are you sure you want to remove this limit?',
  method: 'method',
  url: 'Url',
  roleId: 'Role ID',
  permissionId: 'Permission ID',
  role: 'Role',
  realms: 'Realms',
  roleInfo: 'Role info',
  licensePermissionInfo: 'License permission info'
}
